import {
  MaintenanceAlert,
  MaintenanceNotification,
  WillowThemeContextValue,
} from '@branch-messenger/willow-ui'
import { AppError, AppLayout } from '@components/AppLayout'
import { WhiteLabelApps } from '@customTypes/white-label'
import { orgDetailsQueryOptions } from '@src/queryOptions/org'
import { Store } from '@store/index'
import { QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { zodValidator } from '@tanstack/zod-adapter'

import { rootSearchSchema } from './-searchSchemas/rootSearchSchema'

export type RouterContext = {
  fireMixpanelEvent: (event: string) => void
  queryClient: QueryClient
  store: Store
  setTheme: WillowThemeContextValue['setTheme']
}

const maintenanceComponentId = 't3bqc4bhkbh5'

export const Route = createRootRouteWithContext<RouterContext>()({
  validateSearch: zodValidator(rootSearchSchema.pick({ org: true })),
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({
    deps: { search },
    context: { setTheme, store, queryClient },
  }) => {
    const { org } = search
    const isInitialized = store.getState().onboarding.appInitialized
    if (!isInitialized && org) {
      const orgDetails = await queryClient.ensureQueryData(
        orgDetailsQueryOptions({ organizationId: org })
      )
      const appId = orgDetails.data.app_identifier
      switch (appId) {
        case WhiteLabelApps.SHIFTKEY:
          setTheme('shiftKey')
          break
        default:
          setTheme('branch')
      }
    }
  },
  component: () => {
    return (
      <>
        <MaintenanceAlert componentId={maintenanceComponentId} />
        <MaintenanceNotification componentId={maintenanceComponentId} />
        <AppLayout />
        <ReactQueryDevtools buttonPosition="bottom-right" />
        <TanStackRouterDevtools />
      </>
    )
  },
  errorComponent: AppError,
})
